export const LOGGING_CONFIG = {
  // Logs generales de la aplicación
  APP: false,
  
  // Logs de almacenamiento (stores)
  CATEGORIES_STORE: false,
  ELEMENTS_STORE: false,
  UNIFIED_ELEMENTS_STORE: false,
  IFC_STORE: false,
  GLOBAL_STORE: false,
  FINCAS_STORE: false,
  IFC_FINE_TUNING_STORE: false,
  PERSIST_MIGRATION: false,
  
  // Logs de paneles
  ELEMENTS_TABLE_PANEL: false,
  IFC_INPUT_PANEL: false,
  DRAWING_PANEL: false,
  CALCULATIONS_PANEL: false,
  EXPORT_PANEL: false,

  // Logs específicos por componente/servicio
  DRAWING_SERVICE: false,
  UI_SERVICE: false,
  IFC_SERVICE: false,
  MAP_COMPONENT: false,
  USE_IFC: false,
  
  // Logs de servicios específicos
  DRAWING: false,
  MAP: false,
  REPORTS: false,
  MAP_SERVICE: false,
  UPDATE_SERVICE: false,
  
  // Logs de errores (siempre activos)
  ERRORS: true,
  
  // Logs de IFC 
  IFC: false,
  IFC_MODEL: false,

};
